/* ═══════════════════════════════════════════════════════════
   RUSTIC — behavior layer (ported from the redesign's main.js)
   Runs alongside Dawn. Deliberately does NOT hijack link clicks
   (that would swallow Dawn's cart-drawer / menu triggers) and
   does NOT mark the active nav item (Dawn already does).
   initRustic() is re-run on shopify:section:load so sections
   stay alive while editing in the theme editor.
   ═══════════════════════════════════════════════════════════ */
(function () {
  function initRustic(scope) {
    var root = scope || document;

    /* staggered reveal */
    root.querySelectorAll('.rs-grid, .rs-tiles, .rs-claim-chips').forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (el, i) {
        el.style.setProperty('--rd', (i % 4) * 0.1 + 's');
      });
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('visible');
        if (e.target.classList.contains('rs-rail-wrap')) {
          e.target.querySelectorAll('.rs-card').forEach(function (c, i) {
            c.style.setProperty('--rd', (i % 10) * 0.08 + 's');
            c.classList.add('visible');
          });
        }
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('.rs-reveal').forEach(function (el) { io.observe(el); });

    /* fade images in as they load — kills the blank-box flash */
    root.querySelectorAll('.rs-card-media img, .rs-tile img, .rs-spot-img').forEach(function (im) {
      var mark = function () { im.classList.add('ld'); };
      if (im.complete && im.naturalWidth > 0) mark();
      else { im.addEventListener('load', mark); im.addEventListener('error', mark); }
    });

    /* hero depth — background drifts slower than the page */
    var heroBg = root.querySelector('.rs-hero-bg');
    if (heroBg) {
      var kbDone = false;
      heroBg.addEventListener('animationend', function () { kbDone = true; });
      addEventListener('scroll', function () {
        if (!kbDone || scrollY > innerHeight) return;
        heroBg.style.animation = 'none';
        heroBg.style.transform = 'translateY(' + (scrollY * 0.25).toFixed(1) + 'px) scale(1.02)';
      }, { passive: true });
    }

    /* gentle parallax on banner imagery */
    var px = Array.prototype.slice.call(root.querySelectorAll('.rs-banner-media img'));
    if (px.length) {
      var move = function () {
        px.forEach(function (el) {
          var r = el.parentElement.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) return;
          var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          el.style.transform = 'scale(1.14) translateY(' + (p * -26).toFixed(1) + 'px)';
        });
      };
      addEventListener('scroll', move, { passive: true });
      move();
    }

    /* product rail — arrows + defeat macOS scroll-latching */
    root.querySelectorAll('.rs-rail-wrap').forEach(function (w) {
      var rail = w.querySelector('.rs-rail'),
          prev = w.querySelector('.rs-prev'),
          next = w.querySelector('.rs-next');
      if (!rail) return;
      // arrows are optional — rail is swipe-first; wire whichever exist
      // (was previously requiring BOTH prev+next, so a next-only rail — the
      // right-arrow-only rail on the homepage — silently never got wired)
      if (prev || next) {
        var step = function () {
          // was hardcoded +22 (stale desktop gap) — real mobile gap is 10px now,
          // so every click scrolled the wrong distance and fought scroll-snap,
          // which is why it looked like it "wasn't moving." Read the live gap.
          var c = rail.querySelector('.rs-card');
          var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 10;
          return (c ? c.offsetWidth : 260) + gap;
        };
        var update = function () {
          if (prev) prev.toggleAttribute('disabled', rail.scrollLeft < 10);
          if (next) next.toggleAttribute('disabled', rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 10);
        };
        if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
        rail.addEventListener('scroll', update, { passive: true });
        update();
      }
      // a vertical gesture over the rail must scroll the PAGE, not latch the rail
      rail.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          window.scrollBy({ top: e.deltaY, left: 0, behavior: 'instant' });
        }
      }, { passive: false });
    });

    /* shop-by-ritual tabs */
    root.querySelectorAll('.rs-ritual-panels').forEach(function (wrapper) {
      var section = wrapper.closest('.shopify-section') || root;
      section.querySelectorAll('.rs-rtab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          section.querySelectorAll('.rs-rtab').forEach(function (t) { t.classList.remove('on'); });
          section.querySelectorAll('.rs-rpanel').forEach(function (p) { p.classList.remove('on'); });
          tab.classList.add('on');
          var panel = section.querySelector('.rs-rpanel[data-rt="' + tab.dataset.rt + '"]');
          if (panel) panel.classList.add('on');
        });
      });
    });

    /* animated counters */
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target,
            target = parseFloat(el.dataset.count),
            dec = +(el.dataset.decimal || 0),
            suf = el.dataset.suffix || '',
            t0 = performance.now(),
            dur = 1500;
        (function tick(now) {
          var p = Math.min((now - t0) / dur, 1),
              v = target * (1 - Math.pow(1 - p, 3));
          el.textContent = (dec ? v.toFixed(dec) : Math.round(v)) + (p === 1 ? suf : '');
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.6 });
    root.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

    /* story scroller — sticky media follows the steps */
    var steps = Array.prototype.slice.call(root.querySelectorAll('.rs-story-step'));
    if (steps.length) {
      var sio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var n = e.target.dataset.step;
          steps.forEach(function (s) { s.classList.toggle('on', s.dataset.step === n); });
          root.querySelectorAll('.rs-story-media img').forEach(function (im) {
            im.classList.toggle('on', im.dataset.step === n);
          });
        });
      }, { threshold: 0.55 });
      steps.forEach(function (s) { sio.observe(s); });
    }

    /* testimonial spotlight — auto-rotate + dots */
    root.querySelectorAll('.rs-tmn-wrap').forEach(function (wrap) {
      var slides = Array.prototype.slice.call(wrap.querySelectorAll('.rs-tmn-slide')),
          dots = Array.prototype.slice.call(wrap.querySelectorAll('.rs-tmn-dot'));
      if (!slides.length) return;
      var ti = 0, timer;
      var show = function (i) {
        ti = i;
        slides.forEach(function (s, j) { s.classList.toggle('on', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      };
      var auto = function () {
        timer = setInterval(function () { show((ti + 1) % slides.length); }, 5200);
      };
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { clearInterval(timer); show(i); auto(); });
      });
      auto();
    });

    /* FAQ accordion */
    root.querySelectorAll('.rs-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement,
            ans = item.querySelector('.rs-faq-a'),
            open = item.classList.contains('open'),
            list = item.parentElement;
        list.querySelectorAll('.rs-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          i.querySelector('.rs-faq-a').style.maxHeight = 0;
        });
        if (!open) {
          item.classList.add('open');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });

    /* spotlight 3D tilt (desktop pointers only) */
    var spot = root.querySelector('.rs-spot-tilt');
    if (spot && matchMedia('(pointer:fine)').matches) {
      var stage = spot.closest('.rs-spot-stage');
      if (stage) {
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect(),
              x = (e.clientX - r.left) / r.width - 0.5,
              y = (e.clientY - r.top) / r.height - 0.5;
          spot.style.animation = 'none';
          spot.style.transform = 'perspective(700px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 8) + 'deg)';
        });
        stage.addEventListener('mouseleave', function () {
          spot.style.transform = '';
          spot.style.animation = '';
        });
      }
    }

    /* magnetic hero CTA */
    var cta = root.querySelector('.rs-hero-cta');
    if (cta && matchMedia('(pointer:fine)').matches) {
      cta.addEventListener('mousemove', function (e) {
        var r = cta.getBoundingClientRect();
        cta.style.transform = 'translate(' +
          (e.clientX - r.left - r.width / 2) * 0.18 + 'px,' +
          ((e.clientY - r.top - r.height / 2) * 0.3 - 2) + 'px)';
      });
      cta.addEventListener('mouseleave', function () { cta.style.transform = ''; });
    }
  }

  /* back to top — global, bound once */
  function initTopButton() {
    var topBtn = document.querySelector('.rs-top-btn');
    if (!topBtn) return;
    addEventListener('scroll', function () {
      topBtn.classList.toggle('on', scrollY > 800);
    }, { passive: true });
    topBtn.addEventListener('click', function () {
      scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (document.readyState !== 'loading') { initRustic(); initTopButton(); }
  else document.addEventListener('DOMContentLoaded', function () { initRustic(); initTopButton(); });

  /* theme editor: re-init a section when it's re-rendered */
  document.addEventListener('shopify:section:load', function (e) { initRustic(e.target); });
})();
